import * as React from 'react';
const SvgAdd = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <path
            fill='currentColor'
            d='M10.004 16.593a.5.5 0 0 1-.358-.145.48.48 0 0 1-.147-.357v-5.09h-5.09a.5.5 0 0 1-.357-.143.48.48 0 0 1-.145-.354q0-.211.145-.358a.48.48 0 0 1 .357-.147h5.09v-5.09q0-.214.143-.358a.48.48 0 0 1 .354-.144q.211 0 .358.144a.48.48 0 0 1 .147.358v5.09h5.09a.487.487 0 0 1 .502.497q0 .211-.145.358a.48.48 0 0 1-.357.147h-5.09v5.09a.5.5 0 0 1-.143.357.48.48 0 0 1-.354.145'
        />
    </svg>
);
export default SvgAdd;
